<template>
  <div>
    <img src="static/assets/images/142.png" style="width: 100%;height: 600px;"/>
    <!-- Job Single Content Starts -->
    <section class="job-single-content section-padding">
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <div class="section-top text-center">
              <h2>新闻资讯</h2>
              <p>实时关注行内资讯让我们快人一步</p>
            </div>
          </div>
        </div>
<!--        <div class="row">-->
<!--          <div class="col-lg-12">-->
<!--            <div class="jobs-tab tab-item">-->
<!--              <ul>-->
<!--                <li class="active">recent</li>-->
<!--                <li>full time</li>-->
<!--                <li>part time</li>-->
<!--                <li>intern</li>-->
<!--              </ul>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
        <div class="row">
          <div class="col-lg-12">
            <div class="main-content">
              <div class="single-content1">
                <div class="single-job mb-4 d-lg-flex justify-content-between">
                  <div class="job-text" style="width: 80%;">
                    <h4>不折不扣落实中小企业财税支持政策</h4>
                    <ul class="mt-4">
                      <li class="mb-3"><h5><i class="fa fa-pie-chart"></i> 本报北京8月26日电 (记者曲哲涵)一段时间以来,一系列支持中小企业发展的财税政策出台,财政部近日下发《关于加强财税支持政策落实 促进中小企业高质量发展的通知》(以下简称《...</h5></li>
                      <li><h5><i class="fa fa-clock-o"></i> 2023-08-26</h5></li>
                      <router-link to="/msg1" class="secondary-btn">查看详情<span class="flaticon-next"></span></router-link>
                    </ul>
                  </div>
                  <div class="job-img align-self-center">
                    <img src="static/assets/images/job3.png" alt="job" style="width: 126px;height: 126px;">
                  </div>
                </div>
                <div class="single-job mb-4 d-lg-flex justify-content-between">
                  <div class="job-text" style="width: 80%;">
                    <h4>税收大利好，创投圈热议！</h4>
                    <ul class="mt-4">
                      <li class="mb-3"><h5><i class="fa fa-pie-chart"></i> 同时,也刺激GP和LP之间有意识地真正去把握自身的退出节奏,然后选择合适的税筹方案。比如选择按照单一投资基
                        金核算的GP,从税筹...</h5></li>
                      <li><h5><i class="fa fa-clock-o"></i> 2023-08-24</h5></li>
                      <router-link to="/msg2" class="secondary-btn">查看详情<span class="flaticon-next"></span></router-link>
                    </ul>
                  </div>
                  <div class="job-img align-self-center">
                    <img src="static/assets/images/job2.png" alt="job" style="width: 126px;height: 126px;">
                  </div>
                </div>
                <div class="single-job mb-4 d-lg-flex justify-content-between">
                  <div class="job-text" style="width: 80%;">
                    <h4>2023年最新灵活用工相关政策</h4>
                    <ul class="mt-4">
                      <li class="mb-3"><h5><i class="fa fa-pie-chart"></i> 人社部：《人力资源服务机构管理规定》2023年8月1日起施行，严禁以欺诈、胁迫、诱导劳动者注册为个体工商户第二十八条 经营性人力资源服务机构接受用人单位委托，提供人力资源管理、开发、配置等人力资源服务外包的，不得有下列行...</h5></li>
                      <li><h5><i class="fa fa-clock-o"></i> 2023-06-30</h5></li>
                      <router-link to="/msg3" class="secondary-btn">查看详情<span class="flaticon-next"></span></router-link>
                    </ul>
                  </div>
                  <div class="job-img align-self-center">
                    <img src="static/assets/images/job4.png" alt="job" style="width: 126px;height: 126px;">
                  </div>
                </div>
              </div>
            </div>
<!--            <div class="more-job-btn mt-5 text-center">-->
<!--              <a href="#" class="template-btn">more job post</a>-->
<!--            </div>-->
          </div>
<!--          <div class="col-lg-4">-->
<!--            <div class="sidebar mt-5 mt-lg-0">-->
<!--              <div class="single-item mb-4">-->
<!--                <h4 class="mb-4">jobs type</h4>-->
<!--                <a href="#" class="sidebar-btn d-flex justify-content-between mb-3">-->
<!--                  <span>Full Time</span>-->
<!--                  <span class="text-right">25 job</span>-->
<!--                </a>-->
<!--                <a href="#" class="sidebar-btn d-flex justify-content-between mb-3">-->
<!--                  <span>Part Time</span>-->
<!--                  <span class="text-right">25 job</span>-->
<!--                </a>-->
<!--                <a href="#" class="sidebar-btn d-flex justify-content-between">-->
<!--                  <span>Internship</span>-->
<!--                  <span class="text-right">25 job</span>-->
<!--                </a>-->
<!--              </div>-->
<!--              <div class="single-item mb-4">-->
<!--                <h4 class="mb-4">job by location</h4>-->
<!--                <a href="#" class="sidebar-btn d-flex justify-content-between mb-3">-->
<!--                  <span>New York</span>-->
<!--                  <span class="text-right">25 job</span>-->
<!--                </a>-->
<!--                <a href="#" class="sidebar-btn d-flex justify-content-between mb-3">-->
<!--                  <span>California</span>-->
<!--                  <span class="text-right">25 job</span>-->
<!--                </a>-->
<!--                <a href="#" class="sidebar-btn d-flex justify-content-between mb-3">-->
<!--                  <span>Swizerland</span>-->
<!--                  <span class="text-right">25 job</span>-->
<!--                </a>-->
<!--                <a href="#" class="sidebar-btn d-flex justify-content-between mb-3">-->
<!--                  <span>Canada</span>-->
<!--                  <span class="text-right">25 job</span>-->
<!--                </a>-->
<!--                <a href="#" class="sidebar-btn d-flex justify-content-between">-->
<!--                  <span>Sweden</span>-->
<!--                  <span class="text-right">25 job</span>-->
<!--                </a>-->
<!--              </div>-->
<!--              <div class="single-item mb-4">-->
<!--                <h4 class="mb-4">salary range</h4>-->
<!--                <a href="#" class="sidebar-btn d-flex justify-content-between mb-3">-->
<!--                  <span>$20,000-$30,000</span>-->
<!--                  <span class="text-right">25 job</span>-->
<!--                </a>-->
<!--                <a href="#" class="sidebar-btn d-flex justify-content-between mb-3">-->
<!--                  <span>$25,000-$45,000</span>-->
<!--                  <span class="text-right">25 job</span>-->
<!--                </a>-->
<!--                <a href="#" class="sidebar-btn d-flex justify-content-between">-->
<!--                  <span>$40,000-$70,000</span>-->
<!--                  <span class="text-right">25 job</span>-->
<!--                </a>-->
<!--              </div>-->
<!--              <div class="single-item">-->
<!--                <h4 class="mb-4">filter by salary</h4>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
        </div>
      </div>
    </section>
    <!-- Job Single Content End -->


    <!-- Newsletter Area Starts -->
<!--    <section class="newsletter-area job-single section-padding">-->
<!--      <div class="container">-->
<!--        <div class="row">-->
<!--          <div class="col-lg-12">-->
<!--            <div class="section-top text-center">-->
<!--              <h2>Get job information daily</h2>-->
<!--              <p>Subscribe to our newsletter and get a coupon code!</p>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--        <div class="row">-->
<!--          <div class="col-lg-12">-->
<!--            <form action="#">-->
<!--              <input type="email" placeholder="Your email here" onfocus="this.placeholder = ''" onblur="this.placeholder = 'Your email here'" required>-->
<!--              <button type="submit" class="template-btn">subscribe now</button>-->
<!--            </form>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--    </section>-->
    <!-- Newsletter Area End -->
  </div>
</template>

<script>
  export default {}
</script>




// WEBPACK FOOTER //
// src/pages/JobCategory.vue